import { render } from "./SocialCard.vue?vue&type=template&id=19725796&scoped=true"
import script from "./SocialCard.vue?vue&type=script&lang=js"
export * from "./SocialCard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-19725796"

export default script